
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"26","height":"30","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M13.002 1.156l11.561 6.675.425 14.093L13 28.845 1.437 22.17l-.41-13.61 11.975-7.403z","stroke":"#02D0D2","stroke-width":"2","fill":"none","fill-rule":"evenodd"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      